export default "__VITE_ASSET__Ej$HLycg__"